import { render, staticRenderFns } from "./bulletins2.vue?vue&type=template&id=55454798"
import script from "./bulletins2.vue?vue&type=script&lang=js"
export * from "./bulletins2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports